import * as yup from "yup";

import { email } from "./messages";

export const emailValidation = (): yup.StringSchema<
  string,
  Record<string, unknown>,
  string
> => yup.string().email(email.wrongFormat);
